// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"206":"3f5a270d","657":"28e44dfb"}[chunkId] + ".chunk.css";
};